import { useAuthContext } from '@providers/AuthProvider';
import { Link as RouterLink } from 'react-router-dom';
import BackIcon from '@components/icons/Back.svg';
import { TProps } from './types/TProps';

export const BackButton = ({ backRoute }: TProps) => {
  const { me } = useAuthContext();

  if (!me) {
    return null;
  }

  if (!backRoute) {
    return null;
  }
  return (
    <RouterLink
      aria-label="Back"
      to={backRoute}
      className="inline-flex min-h-11 min-w-11 items-center justify-center text-foreground font-normal text-base leading-none underline hover:text-link"
    >
      <BackIcon className="text-[var(--color-title)] hover:text-[var(--color-fixed-brand)]" />
    </RouterLink>
  );
};
